import { Icon } from '@iconify/react'

import { getCardMetaIcons } from '../utils'
import styles from '../../ProjectStoryMapBoard.module.css'

const CardMetaIcons = ({ item }) => {
    const icons = getCardMetaIcons(item)

    if (!icons.length) return null

    return (
        <div className={styles.cardMetaIcons} aria-hidden={false}>
            {icons.map(({ key, icon, label }) => (
                <span key={key} className={styles.cardMetaIcon} title={label}>
                    <Icon icon={icon} width={14} />
                </span>
            ))}
        </div>
    )
}

export default CardMetaIcons
